import Backbone from 'backbone';
import Filter from 'app/src/data/models/utils/Filter';
import AuthValidator from 'app/router/AuthValidator';

export default class RetailCollection extends Backbone.Collection {
  /**
   * Override the fetch method to optionally pass a Filter as a parameter,
   * in addition to the existing options parameter
   *
   * @param filter {Filter} optional filter to apply to the fetch
   * @param options {object} optional hash of additional settings to pass to the fetch
   * @return {Promise} that resolves when the fetch succeeds and fails otherwise
   */
  fetch(filter, options = {}) {
    if (filter instanceof Filter) {
      options.data = filter.getQueryParameters();
    } else {
      options = filter;
    }

    let promise = super.fetch(options);
    promise.fail(jqXHR => {
      AuthValidator.validateStatus(jqXHR.status);
    });

    return promise;
  }

  /**
   * Underscore's _.intersection() doesn't really work for backbone objects
   * This is a version of it that works by comparing backbone model IDs
   *
   * @param collection1 - Array of Backbone objects
   * @param collection2 - Array of Backbone objects
   * @returns {Array} - The intersection of the Backbone object arrays
   */
  static intersectionByModelID(collection1, collection2) {
    let intersection = [];
    collection1.forEach(itemFromCollection1 => {
      collection2.forEach(itemFromCollection2 => {
        if (itemFromCollection1.id === itemFromCollection2.id) {
          intersection.push(itemFromCollection1);
        }
      });
    });

    return intersection;
  }

  /**
   * Underscore's _.difference() doesn't really work for backbone objects
   * This is a version of it that works by comparing backbone model IDs
   *
   * Finds objects that are NOT common between collection 1 and collection 2
   *
   * @param collection1 - Array of Backbone objects
   * @param collection2 - Array of Backbone objects
   * @returns {Array} - The intersection of the Backbone object arrays
   */
  static differenceByModelID(collection1, collection2) {
    // See what's in Collection1 but not in Collection1
    let difference = RetailCollection.relativeComplementByModelID(collection1, collection2);

    // Now do the reverse!
    difference = difference.concat(
      RetailCollection.relativeComplementByModelID(collection2, collection1)
    );

    return difference;
  }

  /**
   * Finds objects that are in Collection1 but not in Collection2
   *
   * @param collection1 - Array of Backbone objects
   * @param collection2 - Array of Backbone objects
   * @returns {Array} - Array of objects in Collection1 but not in Collection2
   */
  static relativeComplementByModelID(collection1, collection2) {
    let difference = [];

    collection1.forEach(itemFromCollection1 => {
      let found = false;
      collection2.forEach(itemFromCollection2 => {
        if (itemFromCollection1.id === itemFromCollection2.id) {
          found = true;
        }
      });

      if (!found) {
        difference.push(itemFromCollection1);
      } else {
        found = false;
      }
    });

    return difference;
  }
}
